<script>
import { mapActions, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import { requiredIf } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "UpdatekiosksMultiple",
  components: { Multiselect, DatePicker },
  data() {
    return {
      dateFormatOptions: ["yyyy-MM-dd", "dd-MM-yyyy", "MM-dd-yyyy"],
      tempOptions: [
        { text: "° C", value: "c" },
        { text: "° F", value: "f" },
      ],
      weigOptions: [
        { text: "26", value: "26" },
        { text: "34", value: "34" },
      ],
      timeZoneName: null,
      form: {
        kiosks_setting: {
          temperature_offset: 0,
          kiosk_brightness: 65,
          schedule_reboot: null,
          kiosk_volume: 50,
          temperature_display_unit: null,
          time_zone: null,
          schedule_reboot_time: "03:00",
          system_fan: 0,
          enable_company_logo: 1,
          living_body: 1,
          card_logo_image: "",
          date_format: "yyyy-mm-dd",
          show_status_bar: 0,
          rfid_counter: 5,
          weigand_output_type: 26,
          custom_smtp_server: 0,
          smtp_address: null,
          smtp_username: null,
          smtp_password: null,
          smtp_port: null,
          smtp_tls: 0,
          smtp_ssl: 0,
        },
        site_id: null,
        area_id: null,
      },
      submitted: false,
      timezoneObject: null,
      confirmUpdate: false,
      entity: null,
      modalId: null,
    };
  },
  validations: {
    form: {
      kiosks_setting: {
        smtp_port: {
          required: requiredIf(function () {
            return this.form.kiosks_setting.custom_smtp_server;
          }),
        },
        smtp_address: {
          required: requiredIf(function () {
            return this.form.kiosks_setting.custom_smtp_server;
          }),
        },
        smtp_username: {
          required: requiredIf(function () {
            return this.form.kiosks_setting.custom_smtp_server;
          }),
        },
        smtp_password: {
          required: requiredIf(function () {
            return this.form.kiosks_setting.custom_smtp_server;
          }),
        },
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("kiosks", ["getLoading", "getKiosksSettings"]),
    ...mapGetters("authfack", ["currentEntity"]),
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide(this.modalId);
    },
  },
  methods: {
    ...mapActions("kiosks", ["updateKiosksSettings"]),
    clearRebootTime() {
      this.form.kiosks_setting.schedule_reboot_time = "00:00:00";
    },
    onSubmit() {
      this.form.kiosks_setting.time_zone = this.timeZoneName
        ? this.timeZoneName
        : null;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submitted = true;
        this.$emit(
          "updateKioskSettings",
          {
            params: this.form,
          },
          this.modalId
        );
      }
    },
    allowUpdate() {
      return (this.confirmUpdate = true);
    },
  },
  beforeMount() {
    this.entity = this.getModalInfo;
    this.modalId = this.getModalInfo.modalId;

    if (this.getModalInfo.hasOwnProperty("parent_id")) {
      this.form.area_id = this.getModalInfo["id"];
    } else {
      this.form.site_id = this.getModalInfo["id"];
    }
    this.timezoneObject = moment.tz.names();
    let massKiosksettings =
      this.getModalInfo.massKioskSiteSettings ||
      this.getModalInfo.mass_kiosk_site_settings;

    massKiosksettings?.forEach((item) => {
      item.name == "temperature_display_unit"
        ? (this.form.kiosks_setting.temperature_display_unit = item.pivot.value)
        : "";
      item.name == "temperature_offset"
        ? (this.form.kiosks_setting.temperature_offset = Number(
            item.pivot.value
          ))
        : "";
      item.name == "schedule_reboot"
        ? (this.form.kiosks_setting.schedule_reboot =
            item.pivot.value == 1 ? true : false)
        : "";
      item.name == "kiosk_volume"
        ? (this.form.kiosks_setting.kiosk_volume = Number(item.pivot.value))
        : "";
      item.name == "kiosk_brightness"
        ? (this.form.kiosks_setting.kiosk_brightness = Number(item.pivot.value))
        : "";
      // new settings
      item.name == "time_zone" ? (this.timeZoneName = item.pivot.value) : "";
      item.name == "schedule_reboot_time"
        ? (this.form.kiosks_setting.schedule_reboot_time = item.pivot.value)
        : "";
      item.name == "system_fan"
        ? (this.form.kiosks_setting.system_fan =
            item.pivot.value == 1 ? true : false)
        : "";
      item.name == "enable_company_logo"
        ? (this.form.kiosks_setting.enable_company_logo = item.pivot.value)
        : "";
      item.name == "living_body"
        ? (this.form.kiosks_setting.living_body =
            item.pivot.value == 1 ? true : false)
        : "";
      item.name == "date_format"
        ? (this.form.kiosks_setting.date_format = item.pivot.value)
        : "";
      item.name == "show_status_bar"
        ? (this.form.kiosks_setting.show_status_bar =
            item.pivot.value == 1 ? true : false)
        : "";
      item.name == "kiosk_brightness"
        ? (this.form.kiosks_setting.kiosk_brightness = Number(item.pivot.value))
        : "";
      item.name == "rfid_counter"
        ? (this.form.kiosks_setting.rfid_counter = Number(item.pivot.value))
        : "";
      item.name == "weigand_output_type"
        ? (this.form.kiosks_setting.weigand_output_type = item.pivot.value)
        : "";
      item.name == "smtp_address"
        ? (this.form.kiosks_setting.smtp_address = item.pivot.value)
        : "";
      item.name == "smtp_port"
        ? (this.form.kiosks_setting.smtp_port = item.pivot.value)
        : "";
      item.name == "smtp_username"
        ? (this.form.kiosks_setting.smtp_username = item.pivot.value)
        : "";
      item.name == "smtp_password"
        ? (this.form.kiosks_setting.smtp_password = item.pivot.value)
        : "";
      item.name == "smtp_tls"
        ? (this.form.kiosks_setting.smtp_tls =
            item.pivot.value == 1 ? true : false)
        : "";
      item.name == "smtp_ssl"
        ? (this.form.kiosks_setting.smtp_ssl =
            item.pivot.value == 1 ? true : false)
        : "";
      item.name == "custom_smtp_server"
        ? (this.form.kiosks_setting.custom_smtp_server =
            item.pivot.value == 1 ? true : false)
        : "";
    });
  },
};
</script>

<template>
  <section>
    <div v-if="!confirmUpdate" class="confirmation-warning">
      <p class="first-title">
        {{ entity.dataType.charAt(0).toUpperCase() + entity.dataType.slice(1) }}
        Kiosks Settings
      </p>
      <h4 class="question-msg">
        Are you sure you want to<strong class="question-msg-bold"
          >"Edit"</strong
        >
        the settings for all the kiosks in this {{ entity.dataType }}?
      </h4>
      <div class="vertical-line"></div>
      <div class="actions-btns">
        <button
          :disabled="getLoading"
          class="submit-btn btn btn-primary add-submit"
          size="md"
          @click="allowUpdate"
        >
          <i
            v-if="getLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          Edit
        </button>
        <button
          class="btn btn-outline-danger cancel-reject"
          @click="$bvModal.hide(modalId)"
        >
          Cancel
        </button>
      </div>
    </div>
    <div v-else class="kiosk-form-wrapper">
      <h4 class="allareakiosk-header">Kiosks Settings</h4>
      <!-- switchs  -->
      <div class="switchs-wrapper">
        <div class="kiosk-switch-settings">
          <!-- system fan -->
          <b-form-group
            class="first-one"
            label="System Fan"
            label-for="system_fan"
          >
            <b-form-checkbox
              size="md"
              class="switch-gray radio-updateArea"
              id="system_fan"
              switch
              :disabled="submitted"
              v-model="form.kiosks_setting.system_fan"
            ></b-form-checkbox>
          </b-form-group>
          <div class="line-betwen"></div>
          <!-- schedule reboot -->
          <b-form-group
            class="second-one"
            label="Schedule Reboot"
            label-for="schedule_reboot"
          >
            <b-form-checkbox
              class="switch-gray radio-updateArea"
              id="schedule_reboot"
              switch
              size="md"
              :disabled="submitted"
              v-model="form.kiosks_setting.schedule_reboot"
            ></b-form-checkbox>
          </b-form-group>
          <div class="line-betwen"></div>
          <!-- living body -->
          <b-form-group
            class="third-one"
            label="Living Body"
            label-for="living_body"
          >
            <b-form-checkbox
              class="switch-gray radio-updateArea"
              id="living_body"
              switch
              size="md"
              :disabled="submitted"
              v-model="form.kiosks_setting.living_body"
            ></b-form-checkbox>
          </b-form-group>
        </div>
        <!-- status bar -->
        <b-form-group
          class="col-lg-6 mt-4 last-one"
          label="Hide Status Bar"
          label-for="status_bar"
        >
          <b-form-checkbox
            class="switch-gray radio-updateArea"
            id="status_bar"
            switch
            size="md"
            v-model="form.kiosks_setting.show_status_bar"
            :disabled="submitted"
            style="inset-inline-start: 1.2rem"
          ></b-form-checkbox>
        </b-form-group>
      </div>
      <div class="form-groups multi-inputs">
        <div class="actionsline-inside"></div>
        <!-- date format   -->
        <b-form-group>
          <multiselect
            id="date"
            v-model="form.kiosks_setting.date_format"
            :options="dateFormatOptions"
            type="text"
            placeholder="Date format"
            :show-labels="false"
            :allowEmpty="true"
            :disabled="submitted"
          />
        </b-form-group>
        <!-- timezone  -->
        <b-form-group>
          <multiselect
            id="timezone"
            v-model="timeZoneName"
            :options="timezoneObject"
            placeholder="Time Zone"
            :show-labels="false"
            :allowEmpty="true"
            :disabled="true"
          />
        </b-form-group>
        <!-- schedule_reboot_time  -->
        <div class="robot-time" style="width: 415px">
          <b-form-group
            style="position: relative"
            label-cols-sm="6"
            label-cols-lg="6"
            label="Reboot Time"
            id="robot"
            label-for="time_reboot"
          >
            <i
              v-if="form.kiosks_setting.schedule_reboot_time"
              :class="{
                'bg-blue':
                  form.kiosks_setting.schedule_reboot_time != '00:00:00',
              }"
              class="mdi mdi-clock mdi-24px clock-icon"
            ></i>

            <i
              @click="clearRebootTime()"
              v-if="form.kiosks_setting.schedule_reboot_time != '00:00:00'"
              :disabled="submitted"
              class="mdi mdi-close-circle mdi-24px close-icon"
            ></i>
            <date-picker
              class="float-right"
              :class="{
                'no-time-width':
                  form.kiosks_setting.schedule_reboot_time == '00:00:00',
                'with-time-width':
                  form.kiosks_setting.schedule_reboot_time != '00:00:00',
              }"
              :disabled="submitted"
              v-model="form.kiosks_setting.schedule_reboot_time"
              type="time"
              value-type="format"
              placeholder="Select Time"
            ></date-picker>
          </b-form-group>
        </div>
      </div>
      <div class="temp-radios">
        <div class="actionsline-inside"></div>
        <!-- temp  -->
        <b-form-group
          class="temp-type align-items-center"
          label="Temperature Unit"
          label-for="temperature"
          label-cols-sm="12"
          label-cols-lg="12"
        >
          <div>
            <v-radio-group
              v-model="form.kiosks_setting.temperature_display_unit"
              :disabled="submitted"
            >
              <v-radio
                v-for="option in tempOptions"
                :key="option.value"
                :label="option.text"
                :value="option.value"
              ></v-radio>
            </v-radio-group>
          </div>
        </b-form-group>
        <!-- weigand output type  -->
        <b-form-group
          class="tweigand-output align-items-center"
          label="Weigand Output Type"
          label-for="temperature"
          label-cols-sm="12"
          label-cols-lg="12"
        >
          <div>
            <v-radio-group
              v-model="form.kiosks_setting.weigand_output_type"
              :disabled="submitted"
            >
              <v-radio
                v-for="option in weigOptions"
                :key="option.value"
                :label="option.text"
                :value="option.value"
              ></v-radio>
            </v-radio-group>
          </div>
        </b-form-group>
      </div>
      <!-- temperature offset  -->
      <div class="temp-offset">
        <div class="actionsline-inside"></div>

        <div
          class="d-flex justify-content-between"
          style="width: 415px; align-items: center; margin-bottom: 30px"
        >
          <h5 class="slider-header">Temperature Offset</h5>
          <div>
            <span class="average-con">
              {{ form.kiosks_setting.temperature_offset }} °{{
                form.kiosks_setting.temperature_display_unit
              }}
            </span>
          </div>
        </div>
        <div
          class="d-flex align-items-center"
          style="width: 415px; align-items: center; margin-bottom: 38px"
        >
          <b-slider
            v-model="form.kiosks_setting.temperature_offset"
            :min="
              form.kiosks_setting.temperature_display_unit == 'c' ? -10 : -20
            "
            :max="form.kiosks_setting.temperature_display_unit == 'c' ? 10 : 20"
            :tooltip-always="false"
            :indicator="false"
            :step="0.1"
            size="is-medium"
            :disabled="submitted"
            :rounded="true"
          ></b-slider>
        </div>
        <!-- </b-form-group> -->
        <!-- brightness  -->
        <div
          class="d-flex justify-content-between"
          style="width: 415px; align-items: center; margin-bottom: 30px"
        >
          <h5 class="slider-header">Brightness</h5>
          <div class="average-con">
            <span> {{ form.kiosks_setting.kiosk_brightness }} % </span>
          </div>
        </div>
        <div
          class="d-flex align-items-center"
          style="margin-top: 30px; margin-bottom: 38px"
        >
          <b-slider
            v-model="form.kiosks_setting.kiosk_brightness"
            :min="0"
            :max="100"
            :tooltip-always="false"
            :indicator="false"
            size="is-medium"
            :disabled="submitted"
            :rounded="true"
          ></b-slider>
        </div>
        <!-- volume  -->
        <div
          class="d-flex justify-content-between"
          style="width: 415px; align-items: center; margin-bottom: 30px"
        >
          <h5 class="slider-header">Volume</h5>
          <div class="average-con">
            <span> {{ form.kiosks_setting.kiosk_volume }} % </span>
          </div>
        </div>

        <div
          class="d-flex align-items-center"
          variant="primary"
          style="margin-top: 30px; margin-bottom: 38px"
        >
          <b-slider
            v-model="form.kiosks_setting.kiosk_volume"
            :min="0"
            :max="100"
            :tooltip-always="false"
            :indicator="false"
            size="is-medium"
            :rounded="true"
            :disabled="submitted"
          ></b-slider>
        </div>

        <!-- rfid counter  -->
        <div
          class="d-flex justify-content-between"
          style="width: 415px; align-items: center; margin-bottom: 30px"
        >
          <h5 class="slider-header">RFID Counter (Seconds)</h5>
          <div class="average-con">
            <span> {{ form.kiosks_setting.rfid_counter }} sec </span>
          </div>
        </div>

        <div
          class="d-flex align-items-center"
          variant="primary"
          style="margin-top: 30px; margin-bottom: 38px"
        >
          <b-slider
            v-model="form.kiosks_setting.rfid_counter"
            :min="0"
            :max="10"
            :tooltip-always="false"
            :indicator="false"
            size="is-medium"
            :rounded="true"
            :disabled="submitted"
          ></b-slider>
        </div>
      </div>
      <!-- custom_smtp_server  -->
      <div class="actionsline-inside"></div>
      <div class="smpt-con">
        <b-form-group
          label-cols-sm="12"
          label-cols-lg="12"
          id="rfid_counter:"
          label="Custom Smtp Server"
          label-for="custom_smtp_server"
        >
          <b-form-checkbox
            size="md"
            class="switch-gray radio-updateArea"
            id="custom_smtp_server"
            switch
            :disabled="submitted"
            v-model="form.kiosks_setting.custom_smtp_server"
            style="inset-inline-start: 1.2rem"
          ></b-form-checkbox>
        </b-form-group>
      </div>

      <!-- smtp settings  -->
      <div class="smtp_settings" v-if="form.kiosks_setting.custom_smtp_server">
        <!-- server address  -->
        <b-form-group>
          <b-form-input
            id="smtp_address"
            style="margin-top: 43px"
            v-model="form.kiosks_setting.smtp_address"
            type="text"
            :disabled="submitted"
            placeholder="Server Address"
            :class="{
              'is-invalid':
                submitted && $v.form.kiosks_setting.smtp_address.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && !$v.form.kiosks_setting.smtp_address.required"
            class="invalid-feedback"
          >
            Smtp address is required.
          </div>
        </b-form-group>
        <!-- port  -->
        <b-form-group>
          <b-form-input
            id="smtp_port"
            v-model="form.kiosks_setting.smtp_port"
            type="text"
            placeholder="Port"
            :disabled="submitted"
            :class="{
              'is-invalid':
                submitted && $v.form.kiosks_setting.smtp_port.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && !$v.form.kiosks_setting.smtp_port.required"
            class="invalid-feedback"
          >
            Smtp port is required.
          </div>
        </b-form-group>
        <!-- user name  -->
        <b-form-group>
          <b-form-input
            id="smtp_username"
            v-model="form.kiosks_setting.smtp_username"
            :disabled="submitted"
            type="text"
            placeholder="User Name"
            :class="{
              'is-invalid':
                submitted && $v.form.kiosks_setting.smtp_username.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && !$v.form.kiosks_setting.smtp_username.required"
            class="invalid-feedback"
          >
            User Name is required.
          </div>
        </b-form-group>
        <!-- smtp password  -->
        <b-form-group autocomplete="off" class="align-items-center text-muted">
          <b-form-input
            autocomplete="new-password"
            :disabled="submitted"
            id="smtp_password"
            v-model="form.kiosks_setting.smtp_password"
            type="password"
            placeholder="Password"
            :class="{
              'is-invalid':
                submitted && $v.form.kiosks_setting.smtp_password.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && !$v.form.kiosks_setting.smtp_password.required"
            class="invalid-feedback"
          >
            Smtp password is required.
          </div>
        </b-form-group>

        <div class="d-flex">
          <!-- smtp_tls  -->
          <div class="d-flex flex-column  pt-4  pb-5" style="margin-inline-end: 30px">
            <b-form-group
              id="rfid_counter:"
              label="Enable TLS"
              label-for="smtp_tls"
            >
            </b-form-group>
            <b-form-checkbox
              :disabled="submitted"
              class="switch-gray radio-updateArea"
              size="md"
              id="smtp_tls"
              switch
              v-model="form.kiosks_setting.smtp_tls"
              style="inset-inline-start: 1.2rem"
            ></b-form-checkbox>
          </div>

          <!-- smtp_ssl  -->
          <div class="d-flex flex-column">
            <b-form-group
              class="pt-4"
              id="rfid_counter:"
              label="Enable ssl"
              label-for="smtp_ssl"
            >
            </b-form-group>

            <b-form-checkbox
              class="switch-gray radio-updateArea pb-5"
              size="md"
              id="smtp_ssl"
              switch
              :disabled="submitted"
              v-model="form.kiosks_setting.smtp_ssl"
              style="inset-inline-start: 1.2rem"
            ></b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="actionsline-inside" style="margin-bottom: 20px"></div>

      <div class="actions-btns">
        <button
          :disabled="getLoading || submitted"
          class="submit-btn btn btn-primary add-submit"
          size="md"
          @click="onSubmit"
        >
          <i
            v-if="getLoading || submitted"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          Save
        </button>
        <button
          class="btn btn-outline-danger cancel-reject"
          :disabled="submitted"
          :class="{ 'cursor-stop': submitted }"
          @click="$bvModal.hide(modalId)"
        >
          Cancel
        </button>
      </div>
    </div>
  </section>
</template>
<style lang="scss">
div[id*="multipleKioskSettings_"] {
  .switch-gray .custom-control-input:checked ~ .custom-control-label::after{
      transform: translateX(1.4rem) !important;
    }
    .switch-gray.radio-updateArea .custom-control-label::after {
      inset-inline-start: -36px !important;
    }
  :disabled {
    cursor: not-allowed;
  }
  .cursor-stop {
    cursor: not-allowed;
  }
  div[class*="modal-content"] {
    width: 579px;
    border-radius: 26px !important;
    .kiosk-switch-settings {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap-reverse;
    }
    .kiosk-switch-settings > div {
      font-weight: 700 !important;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    div[class*="modal-body"] {
      .confirmation-warning {
        .first-title {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          margin-bottom: 40px;
          color: #000000;
        }
        .question-msg {
          font-weight: 400;
          font-size: 20px;
          line-height: 33px;
          margin-inline-start: 7px;
          margin-bottom: 24px;
          text-align: center;

          color: #787878;
          .question-msg-bold {
            font-weight: 700;
            font-size: 20px;
            line-height: 33px;
            margin-inline-start: 7px;
            margin-bottom: 24px;
            text-align: center;

            color: #787878;
          }
        }
        .actionsline-inside {
          background: #707070;
          height: 1px;
          opacity: 0.15;
          width: 488px;
          margin-bottom: 20px;
        }
        .actions-btns {
          display: flex;
          align-items: center;
          justify-content: center;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            margin-inline-end: 15px !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            margin-inline-start: 15px;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
      }
      .kiosk-form-wrapper {
        .b-slider-track,
        .b-slider-fill {
          width: 415px;
          background-color: #0a293d !important;
        }
        .b-slider.is-medium .b-slider-thumb::after {
          content: "||";
          opacity: 0.2;
          color: #000000;
          position: absolute;
          top: 10%;
          inset-inline-start: 33%;
          font-size: 10px;
        }
        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 54px;
          margin-inline-start: 0px;
        }
        .switchs-wrapper {
          .switch-gray.radio-updateArea .custom-control-label::after {
            top: 14px !important;
          }
          .line-betwen {
            height: 34px;
            width: 1px;
            opacity: 0.15;
            background: #707070;
            margin-inline-end: 30px;
          }
          .first-one,
          .second-one,
          .third-one,
          .last-one {
            font-weight: 700 !important;
            font-size: 16px !important;
            line-height: 17px !important;
            letter-spacing: 0.25px;
            color: #787878;
            & label {
              font-weight: 700 !important;
            }
          }
          .last-one {
            margin-top: 45px !important;
          }
        }

        .multi-inputs {
          .actionsline-inside {
            background: #707070;
            height: 1px;
            opacity: 0.15;
            margin-top: 37px;
            margin-bottom: 40px;
            width: 415px;
          }
          input#name {
            height: 55px;
            width: 415px;
            background: #f2f2f2;
            border-radius: 4px;
            border: none;
            outline: none;

            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            position: relative;
            letter-spacing: 0.25px;
            color: rgba(0, 0, 0, 0.87);
            padding-inline-start: 20px;
            transition: 0.6s !important;
            &::placeholder {
              font-weight: 400;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(96, 96, 96, 0.87);
              //opacity: 0.8;
            }
            &:focus::placeholder {
              font-weight: 700 !important;
              font-size: 12px !important;
              line-height: 17px !important;
              letter-spacing: 0.25px;
              z-index: 99999;
              color: #103f5e !important;
              transform: translate(0px, -19px);
              //opacity: 0.8;
            }
          }
          .multiselect {
            width: 415px;
          }
          .multiselect__tags {
            height: 55px !important;
            background: #f2f2f2 !important;
            border-radius: 4px !important;
            border: none !important;
            display: flex;
            align-items: center;
            .multiselect__single {
              background: #f2f2f2 !important;

              font-weight: 700 !important;
              font-size: 16px !important;
              line-height: 17px !important;
              width: 300px !important;
              letter-spacing: 0.25px;
              /* Input text */
              color: rgba(0, 0, 0, 0.87) !important;
              //opacity: 0.8;
            }
            .multiselect__placeholder {
              font-weight: 700 !important;
              font-size: 16px !important;
              line-height: 17px !important;
              padding-inline-start: 10px;

              letter-spacing: 0.25px;

              color: #787878 !important;
            }
          }
          input#area,
          input#journey,
          input#site,
          input#date,
          input#timezone {
            background: #f2f2f2 !important;
            &::placeholder {
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              /* identical to box height, or 106% */

              letter-spacing: 0.25px;

              color: rgba(0, 0, 0, 0.87);

              //opacity: 0.8;
            }
          }
        }
        h5.slider-header {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #787878;
        }
        .average-con {
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f2f2f2;
          border-radius: 7px;
          width: 89px;
          span {
            font-weight: 700;
            font-size: 20px;
            line-height: 46px;
            display: flex;
            align-items: center;
            letter-spacing: 0.25px;
            color: rgba(96, 96, 96, 0.87);
            opacity: 0.8;
          }
        }
        .actionsline-inside {
          background: #707070;
          height: 1px;
          opacity: 0.15;
          margin-top: 37px;
          margin-bottom: 40px;
          width: 415px;
        }

        label#rfid_counter\:__BV_label_ {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #787878;
        }
        input#smtp_address,
        input#smtp_port,
        input#smtp_username,
        input#smtp_password,
        input#kiosk_password,
        input#new_kiosk_password,
        input#confirm_kiosk_password {
          height: 55px;
          width: 415px !important;
          background: #f2f2f2;
          border-radius: 4px;
          border: none;
          outline: none;

          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          position: relative;
          letter-spacing: 0.25px;
          color: rgba(0, 0, 0, 0.87);
          // padding-inline-start: 20px;
          transition: 0.6s !important;
          &::placeholder {
            font-weight: 400;
            font-size: 16px;
            line-height: 17px;
            letter-spacing: 0.25px;
            color: rgba(96, 96, 96, 0.87);
            opacity: 0.8;
          }
          &:focus::placeholder {
            font-weight: 700 !important;
            font-size: 12px !important;
            line-height: 17px !important;
            letter-spacing: 0.25px;
            z-index: 99999;
            color: #103f5e !important;
            transform: translate(0px, -19px);
            //opacity: 0.8;
          }
        }
        .openedPassword {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          margin-inline-end: 16px;

          letter-spacing: 0.25px;

          /* Main Button */

          color: #103f5e;
        }
        .closedPassword {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          margin-inline-end: 16px;
          margin-bottom: 60px;
          letter-spacing: 0.25px;

          color: #787878;
        }
        .actions-btns {
          display: flex;
          align-items: center;
          justify-content: center;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            margin-inline-end: 15px !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            margin-inline-start: 15px;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
        .temp-type,
        .tweigand-output {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #787878;
          margin-top: 10px;
          & label {
            font-weight: 700;
            margin-bottom: 30px;
          }
        }
        label#robot__BV_label_ {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #787878;
          margin-top: 10px;
        }
        input.mx-input {
          height: 55px !important;
          background: #f2f2f2 !important;
          border-radius: 4px;
          border: none !important;
        }
        .mx-input-wrapper input[type="text"] {
          padding-inline-start: 45px !important;
          font-size: 20px !important;
        }

        .clock-icon {
          position: absolute;
          z-index: 1;
          padding: 10px;
          inset-inline-start: 70px;
          top: 19px;
        }
        .close-icon {
          position: absolute;
          z-index: 1;
          inset-inline-end: 0px;
          top: 10px;
          color: #f46a6a;
          cursor: pointer;
        }
        .no-time-width {
          width: 140px !important;
        }
        .with-time-width {
          width: 202px !important;
        }
        .bg-blue {
          color: #103f5e;
          inset-inline-start: 10px;
        }

        .mx-icon-clear,
        .mx-icon-calendar {
          display: none !important;
        }

        div#robot-time {
          width: 183px !important;

          font-weight: 700 !important;
          font-size: 16px !important;
          line-height: 17px !important;
          /* identical to box height, or 106% */

          letter-spacing: 0.25px;

          color: rgba(0, 0, 0, 0.87);

          //opacity: 0.8;
          ::placeholder {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;

            letter-spacing: 0.25px;

            color: #787878;
          }
        }
      }
    }
  }
}
</style>
